import { useKitbagAuth } from '@statsbomb/kitbag-auth';

export const useAuthDetails = () => {
  const { logout, loginWithRedirect, isLoading, ...authState } =
    useKitbagAuth();
  const handleLogin = () =>
    loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search },
      prompt: 'login',
    });
  const handleLogout = () => logout({ returnTo: window.location.origin });
  const { isAuthenticated } = authState;
  return { handleLogin, handleLogout, isAuthenticated, isLoading };
};

export const checkAllowed = (allowed, groups) => {
  if (!allowed) {
    return true;
  }
  return (typeof allowed === 'string' ? [allowed] : allowed).some((role) =>
    groups.includes(role),
  );
};
